import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { EASE, Eyebrow, Reveal } from "./Reveal";

const faqs = [
  {
    q: "Como recebo o e-book depois da compra?",
    a: "Assim que o pagamento é confirmado, você recebe o acesso por e-mail através da Monetizze. O e-book é um PDF interativo que você pode baixar e guardar para sempre.",
  },
  {
    q: "Serve para quem está começando do zero?",
    a: "Sim — o e-book foi escrito exatamente para quem nunca soube por onde começar. Cada capítulo é curto, direto e termina com um exercício prático e um checklist.",
  },
  {
    q: "Vou precisar comprar ingredientes caros ou exóticos?",
    a: "Não. Todo o método foi pensado com comida de verdade, do dia a dia, que você encontra em qualquer mercado de bairro.",
  },
  {
    q: "Posso ler no celular?",
    a: "Pode. O PDF é otimizado para leitura no celular, tablet ou computador — dá para ler tudo numa tarde.",
  },
  {
    q: "E se eu não gostar do conteúdo?",
    a: "Você tem 7 dias de garantia incondicional. Basta pedir o reembolso pela Monetizze e devolvemos 100% do valor, sem perguntas.",
  },
];

const FaqItem = ({ q, a, index }) => {
  const [open, setOpen] = useState(index === 0);
  return (
    <div className="border-b border-linen">
      <button
        data-testid={`faq-item-${index + 1}`}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-4 py-6 text-left"
      >
        <span className="font-serif text-lg font-medium text-ink sm:text-xl">{q}</span>
        <motion.span
          animate={{ rotate: open ? 45 : 0 }}
          transition={{ duration: 0.3, ease: EASE }}
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-linen bg-white text-forest"
        >
          <Plus size={17} />
        </motion.span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: EASE }}
            className="overflow-hidden"
          >
            <p className="max-w-3xl pb-6 text-sm leading-relaxed text-moss sm:text-base">{a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <Reveal>
          <Eyebrow>Dúvidas frequentes</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-4 font-serif text-3xl font-semibold tracking-tight text-ink sm:text-4xl">
            Antes de começar, <span className="italic text-terracotta">tire suas dúvidas</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2} className="mt-10">
          <div className="border-t border-linen">
            {faqs.map((f, i) => (
              <FaqItem key={f.q} q={f.q} a={f.a} index={i} />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
